module.exports = __webpack_public_path__ + "static/keith-tanaka-87aacaf348d558ae8ddaa15cb3ad864f.jpeg";